const authTokenKey = 'authTokenKey';

export const PERFIL_ADMIN = '1';
export const PERFIL_GESTOR_EMPRESA = '2';
export const PERFIL_OPERADOR_EMPRESA = '3';
export const PERFIL_MOTORISTA_EMPRESA = '5';
export const PERFIL_VENDEDOR_EMPRESA = '6';
export const PERFIL_VENDEDOR_AGENCIA = '7';
export const PERFIL_OPERADOR_REMARCACAO = '8';
export const PERFIL_FINANCEIRO_AGENCIA = '9';
export const PERFIL_FISCAL_EMBARQUE = '10';
export const PERFIL_ADMIN_EMPRESA = '11';
export const PERFIL_FINANCEIRO_EMPRESA ='12';
export const PERFIL_FINANCEIRO_CAIXA = '13';
export const PERFIL_GESTOR_OPERACOES = '14';
export const PREFIXO = '_';


export const saveSecurityToken = (authentication) => {
  try {
    localStorage.setItem(authTokenKey, JSON.stringify(authentication));
    return authentication
  } catch (err) {
    console.log(err);
    throw err
  }
};

export const removeSecurityToken = () => {
  try {
    localStorage.removeItem(authTokenKey);
    return authTokenKey
  } catch (err) {
    console.log(err);
    throw err
  }
};

export const getAuthentication = () => {
  try {
    const item = localStorage.getItem(authTokenKey);
    return item ? JSON.parse(item) : item
  } catch (err) {
    console.log(err);
    throw err
  }
};

export const getEmpresas = () => {
  const authentication = getAuthentication();
  if (authentication) {
    const { empresas } = getAuthentication();
    return empresas || []
  }
  return []
};

export const getUsuarioHabilitadoVendaOffline = empresaId => {
  const empresa = getEmpresas().find(e => e.id === empresaId);
  return !!(empresa && empresa.habilitadoVendaOffline);
};

export const getRolesUsuario = () => {
  const authentication = getAuthentication();

  if (authentication) {
    const { roles } = getAuthentication();

    if(roles){
      return roles
    }
    removeSecurityToken();
    window.location.href = '/'
  }
  return []
};

export const getPerfisUsuario = () => getRolesUsuario().map(role => role);

export const getGestorEmpresa = codigoEmpresa => `${PERFIL_GESTOR_EMPRESA}${PREFIXO}${codigoEmpresa}`;
export const getAdminEmpresa = codigoEmpresa => `${PERFIL_ADMIN_EMPRESA}${PREFIXO}${codigoEmpresa}`;
export const getOperadorEmpresa = codigoEmpresa => `${PERFIL_OPERADOR_EMPRESA}${PREFIXO}${codigoEmpresa}`;
export const getVendedorEmpresa = codigoEmpresa => `${PERFIL_VENDEDOR_EMPRESA}${PREFIXO}${codigoEmpresa}`;
export const getOperadorRemarcacao = codigoEmpresa => `${PERFIL_OPERADOR_REMARCACAO}${PREFIXO}${codigoEmpresa}`;
export const getVendedorAgencia = codigoEmpresa => `${PERFIL_VENDEDOR_AGENCIA}${PREFIXO}${codigoEmpresa}`;
export const getFinanceiroAgencia = codigoEmpresa => `${PERFIL_FINANCEIRO_AGENCIA}${PREFIXO}${codigoEmpresa}`;
export const getMotoristaEmpresa = codigoEmpresa => `${PERFIL_MOTORISTA_EMPRESA}${PREFIXO}${codigoEmpresa}`;
export const getFiscalEmbarque = codigoEmpresa => `${PERFIL_FISCAL_EMBARQUE}${PREFIXO}${codigoEmpresa}`;
export const getFinanceiroEmpresa = codigoEmpresa => `${PERFIL_FINANCEIRO_EMPRESA}${PREFIXO}${codigoEmpresa}`;
export const getFinanceiroCaixa = codigoEmpresa => `${PERFIL_FINANCEIRO_CAIXA}${PREFIXO}${codigoEmpresa}`;
export const getGestorOperacoes = codigoEmpresa => `${PERFIL_GESTOR_OPERACOES}${PREFIXO}${codigoEmpresa}`;

export const getPerfisEmpresa = codigoEmpresa => [
  `${PERFIL_GESTOR_EMPRESA}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_OPERADOR_EMPRESA}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_OPERADOR_REMARCACAO}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_VENDEDOR_EMPRESA}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_VENDEDOR_AGENCIA}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_MOTORISTA_EMPRESA}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_FISCAL_EMBARQUE}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_ADMIN_EMPRESA}${PREFIXO}${codigoEmpresa}`
];

export const getPerfisVendedores = codigoEmpresa => [
  `${PERFIL_VENDEDOR_EMPRESA}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_OPERADOR_REMARCACAO}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_VENDEDOR_AGENCIA}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_ADMIN_EMPRESA}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_FISCAL_EMBARQUE}${PREFIXO}${codigoEmpresa}`
];

export const getPerfisAlterarDadosPassageiro = codigoEmpresa => [
  `${PERFIL_VENDEDOR_EMPRESA}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_OPERADOR_REMARCACAO}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_ADMIN_EMPRESA}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_FISCAL_EMBARQUE}${PREFIXO}${codigoEmpresa}`
];

export const getPerfisRemarcacao = codigoEmpresa => [
  `${PERFIL_OPERADOR_REMARCACAO}${PREFIXO}${codigoEmpresa}`,
  `${PERFIL_ADMIN_EMPRESA}${PREFIXO}${codigoEmpresa}`
];

export const hasPerfil = perfil => getPerfisUsuario().includes(perfil);
